import axios, { AxiosError, AxiosResponse } from 'axios';
import { addCancelToken, cancelTokenDict, CustomAxiosRequestConfig, removeCancelToken } from '../helpers/http.helper';

/**
 * If there's an existing cancel token for the URL, cancel it, then create a new cancel token and add
 * it to the dictionary
 * @param {AxiosRequestConfig} config - AxiosRequestConfig - This is the config object that is passed
 * to the axios request.
 * @returns The config object is being returned.
 */
const cancelTokenRequestInterceptor = async function (config: CustomAxiosRequestConfig) {
   const isGetCall = config.method?.toLowerCase() === 'get';
   const shouldCancel = config.cancelable === false;
   if (shouldCancel || !isGetCall) return config;

   if (config.url) {
      const existingCancelToken = cancelTokenDict[config.url];
      if (existingCancelToken) {
         existingCancelToken.cancel('Request canceled due to new request.');
      }
      const cancelToken = axios.CancelToken.source();
      config.cancelToken = cancelToken.token;

      addCancelToken(config.url, cancelToken);
   }

   return config;
};

/**
 * If the response is successful, remove the cancel token from the cancel token map.
 * @param {AxiosResponse} response - AxiosResponse
 * @returns The response object.
 */
const cancelTokenResponseSuccessInterceptors = async function (response: AxiosResponse) {
   removeCancelToken(response?.config?.url);
   return response;
};

/**
 * If the error is a cancel token response error, then reject the promise with the error.
 * @param {AxiosError} error - AxiosError - The error object that was thrown by the request.
 * @returns The error object is being returned.
 */
const cancelTokenResponseErrorInterceptors = async function (error: AxiosError) {
   return await Promise.reject(error);
};

export { cancelTokenRequestInterceptor, cancelTokenResponseSuccessInterceptors, cancelTokenResponseErrorInterceptors };
